import React from 'react'

export default function OfferGTL() {


    const posts = [
        {
            title: "Mainland Company Setup",
            desc: "Explore limitless possibilities with Dubai Setup expert guidance in Mainland company formation in Dubai.",
        },
        {
            title: "Offshore Company Setup",
            desc: "Offshore companies can be created and owned by individuals or institutions, and shares can be easily and freely transferred by a written instrument.",
        },
        {
            title: "Free Zone Company Setup",
            desc: "Explore boundless opportunities with A&A Associate LLC’s Freezone company formation in Dubai, UAE !",
        },
    ]

    return (
        <>
            <section className="py-2 mt-5">
                <div className="max-w-screen-xl mx-auto px-4  gap-x-12 justify-between md:flex md:px-8">
                    <div className="max-w-xxl">
                        <h3 className="text-gray-600 text-3xl font-bold sm:text-3xl pb-5">
                            General Trading LLC (Main-Land)
                        </h3>
                        <h3 className="text-gray-500 text-1xl font-bold sm:text-1xl pb-1">
                            Inclusions
                        </h3>
                        <div className="mt-2 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#1fa1cb" className="bi bi-check" viewBox="0 0 16 16" id="IconChangeColor">
                                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" id="mainIconPathAttribute"></path>
                                </svg>
                                <p className="ml-2"> Medical, Emirates ID, Change Status</p>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#1fa1cb" className="bi bi-check" viewBox="0 0 16 16" id="IconChangeColor">
                                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" id="mainIconPathAttribute"></path>
                                </svg>
                                <p className="ml-2">Residency Visa for Investor</p>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#1fa1cb" className="bi bi-check" viewBox="0 0 16 16" id="IconChangeColor">
                                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" id="mainIconPathAttribute"></path>
                                </svg>
                                <p className="ml-2">Trade License</p>
                            </div>
                        </div>
                        <h3 className="mt-5 text-gray-500 text-1xl font-bold sm:text-1xl pb-1">
                            Deliverables
                        </h3>
                        <div className="mt-2 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#1fa1cb" className="bi bi-check" viewBox="0 0 16 16" id="IconChangeColor">
                                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" id="mainIconPathAttribute"></path>
                                </svg>
                                <p className="ml-2">Trade name</p>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#1fa1cb" className="bi bi-check" viewBox="0 0 16 16" id="IconChangeColor">
                                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" id="mainIconPathAttribute"></path>
                                </svg>
                                <p className="ml-2">Initial approval</p>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#1fa1cb" className="bi bi-check" viewBox="0 0 16 16" id="IconChangeColor">
                                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" id="mainIconPathAttribute"></path>
                                </svg>
                                <p className="ml-2">Payment voucher covered up to AED 27,000</p>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#1fa1cb" className="bi bi-check" viewBox="0 0 16 16" id="IconChangeColor">
                                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" id="mainIconPathAttribute"></path>
                                </svg>
                                <p className="ml-2">PRO charges</p>
                            </div>
                        </div>
                        <h3 className="mt-5 text-gray-500 text-1xl font-bold sm:text-1xl pb-1">
                            What can you do?
                        </h3>
                        <p className="mt-5 text-gray-500 font-small" style={{ lineHeight: 2 }}>
                            A General Trading License specifically allows the holder of the Business License to trade in
                            various items, such as would be the case with a spices store or a supermarket. However, this
                            comes with its own set of restrictions on what you may trade in and what you may not. For
                            example, alcoholic beverages, firearms, and medical / healthcare products cannot be sold
                            without securing additional permits. Dealing with frozen foods and perishable vegetables
                            too comes with its own set of restrictions – you must have a temperature- controlled storage
                            area or godown apart from the retail area.

                        </p>
                    </div>
                </div>
            </section>

            <section className="py-14 max-w-screen-xl mx-auto ">
                <div className="relative overflow-hidden mx-4 px-4 py-14 rounded-2xl bg-blue-600 md:px-8 md:mx-8 main-contact">
                    <div className="relative z-10 max-w-xxl mx-auto sm:text-center">
                        <div className="space-y-3">
                            <h3 className="text-2xl text-customLightBlue font-bold">
                                Have a question? get in touch with us
                            </h3>
                            <h3 className="text-1xl text-white font-bold" style={{ fontSize: 18 }}>
                                Get started with your business needs, we reach out with free and qualified guidance
                            </h3>
                            <h3 className="text-2xl text-white font-bold">
                                Call us today : +971 50 766 8212
                            </h3>
                        </div>
                    </div>
                    <div className="absolute inset-0 w-full h-full" style={{
                        background: "linear-gradient(268.24deg, rgba(31, 41, 55, 0.84) 50%, rgb(102, 102, 102, 0.79) 80.61%, rgba(55, 48, 163, 0) 117.35%, rgba(169, 169, 169, 0.5))"
                    }}></div>

                </div>
            </section>

            <div className="max-w-screen-xxl mx-auto" style={{ paddingBottom: 40, paddingTop: 40, background: "rgb(242, 249, 255)" }}>
                <section className="py-2 mt-5 ">
                    <div className="max-w-screen-xl mx-auto px-4">
                        <h3 className="text-gray-600 text-2xl font-bold sm:text-3xl pb-1 text-center">
                            Our Other <span style={{ color: "#1fa1cb" }}>Services</span>
                        </h3>
                        <p className="text-gray-600 mt-2 text-center font-semibold" style={{ fontSize: 18 }}>
                            Also you can find our Other Services here.
                        </p>
                    </div>
                </section>

                <div className="max-w-screen-xl mx-auto">
                    <div className=" grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
                        {
                            posts.map((items, key) => (
                                <article className="max-w-md mx-auto mt-4 shadow-lg border rounded-md duration-300 hover:shadow-sm bg-white our-other-service" key={key}>
                                    <div className='p-5' >
                                        <a href={items.href}>
                                            <div className="pt-3 ml-4 mr-2 mb-3">
                                                <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-1 " style={{ color: "#1fa1cb" }}>
                                                    {items.title}
                                                </h3>
                                                <p className="text-gray-400 text-sm mt-1 " style={{ fontSize: 14 }}>{items.desc}</p>
                                            </div>
                                        </a>
                                    </div>
                                </article>
                            ))
                        }
                    </div>
                </div>
            </div>



        </>
    )
}
